<div
  class="relative"
  [style.padding-top]="
    siteStore.$bp().ltmd && siteStore.$sw() < 640 ? customPt() ?? '4rem' : '0rem'
  "
  [ngClass]="getClasses()"
>
  <div class="absolute top-0 w-full h-full left-0 sm:hidden opacity-30 overflow-hidden">
    <app-gradient-background></app-gradient-background>
  </div>
  <ng-content select="[slot=children1]"></ng-content>
</div>

<div class="page-sheet-container relative" [ngClass]="getContainerClasses()">
  <ng-content select="[slot=children2]"></ng-content>
</div>
